import { render, staticRenderFns } from "./CloneDataModal.vue?vue&type=template&id=092c7820&scoped=true&"
import script from "./CloneDataModal.vue?vue&type=script&lang=ts&"
export * from "./CloneDataModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092c7820",
  null
  
)

export default component.exports